import * as React from "react";
import { UserCircleIcon } from "@heroicons/react/solid";

interface AvatarProps {
  size?: string;
  color?: string;
}

// Obiect cu dimensiuni predefinite
const sizeMap: Record<string, string> = {
  small: "h-8 w-8",
  medium: "h-12 w-12",
  large: "h-16 w-16",
  xl: "h-24 w-24",
};

const Avatar: React.FC<AvatarProps> = ({
  size = "medium",
  color = "gray-700",
}) => {
  const sizeClass = sizeMap[size] || sizeMap["medium"];

  return <UserCircleIcon className={`${sizeClass} text-${color}`} />;
};

export default Avatar;
